<template>
  <div class="margin-left-xl">
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <evaluationIndexRight></evaluationIndexRight>
    <BigTitle :bigtitle="bigtitle1"></BigTitle>
    <batteryComparentRight/>
    <div class="flex justify-between">
      <div class="margin-right-xs">
        <Table :title="'单次充电记录'" :config="config4" :is400="true"></Table>
      </div>
      <div class="margin-right-xs">
        <div class="margin-top-sm">
          <div class="flex">
            <BatteryRightGauge/>
          </div>
          <BatteryRightLine/>
        </div>
      </div>
      <div>
        <!-- <Table :title="'故障信息'" :config="config5" :is400="true"></Table> -->
      </div>
    </div>
  </div>
</template>

<script>
import Table from "@/components/common/table";
// 头部
import BigTitle from '../bigTitle';
import { formatTime } from '@/utils/index';
import BatteryRightLine from "@/components/echart/batteryBoxCharts/batteryRightLine";
import BatteryRightGauge from "@/components/echart/batteryBoxCharts/batteryRightGauge";

import evaluationIndexRight from "@/views/batteryBox/evaluationIndexRight";

import batteryComparentRight from "@/components/common/batteryCompartment.vue";
import { dataInterface } from '@/api/dataInterfaceApi';




export default {
  data () {
    return {
      options: {},
      bigtitle:{
        CHN:'充电机信息',
        ENG:'Battery compartment'
      },
      bigtitle1:{
        CHN:'充电过程充电机信息',
        ENG:'Battery compartment'
      },
      // 电池服务车辆
      config4: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 42,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 8, //表格行数
        header: [],
        data: [],
      },
      // 电池充电记录
      config5: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 42,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 8, //表格行数
        header: ["告警时间", "告警原因", "工单号"],
        data: [],
      },
    };
  },
  components: {
	BigTitle,
	Table,
  evaluationIndexRight,
  batteryComparentRight,

  BatteryRightLine,
  BatteryRightGauge
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.batterChargeList(data);
      //故障信息
      this.selectMalfunctionMessage(data);
    },
    //TiDB-电池箱-故障信息
    selectMalfunctionMessage(data){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-dianchixiang-guzhangxinxi',
          '@battery_id':data.batteryId
        })
        .then((res) => {
          if(!res) return;
          let newList = [];
          [...res].map(item => {
						let arrlist = [
              formatTime(item.timeOccurrence,'yyyy-MM-dd HH:mm:ss'),
              item.remarks,
              item.workorderNo
            ];
						newList.push(arrlist)
          });
          console.log('newList',newList)
					_this.config5 = {
              headerBGC : 'rgba(53, 149, 147, 0.2)',
              headerHeight : 42,
              carousel : 'single',
              hoverPause : true,
              oddRowBGC : 'rgba(53, 149, 147, 0)',
              evenRowBGC : 'rgba(53, 149, 147, 0)',
              rowNum: 8, //表格行数
              align:['','','center','center'],
              header: ["告警时间", "告警原因", "工单号"],
							data: newList,
					};
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //TiDB-电池箱-单次充电记录
    batterChargeList(data){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-dianchixiang-dancichongdianjilu',
          '@battery_id':data.batteryId
        })
        .then((res) => {
          if(!res) return;
          let newList = [];
          console.log('单次充电记录',res);
          [...res].map(item => {
						let arrlist = [
              formatTime(item.startTime,'yyyy-MM-dd HH:mm:ss'),
              item.batteryId,
              item.chargingTime,
              item.electQuantity
            ];
						newList.push(arrlist)
          });
          console.log('newList',newList)
					_this.config4 = {
              headerBGC : 'rgba(53, 149, 147, 0.2)',
              headerHeight : 42,
              carousel : 'single',
              hoverPause : true,
              oddRowBGC : 'rgba(53, 149, 147, 0)',
              evenRowBGC : 'rgba(53, 149, 147, 0)',
              rowNum: 8, //表格行数
              align:['','','center','center'],
              header: ["充电时间", "电池编码", "充电时长","充电量(kWh)"],
							data: newList,
					};
        })
        .catch((err) => {
          console.log(err);
        });
    },

  
  }
}
</script>
<style lang="scss" scoped>
.header-item{
  color:#0CB3AE;
}
</style>
